// extracted by mini-css-extract-plugin
module.exports = {"brandInformationForm":"BrandInformationForm_brandInformationForm__1hzxM"};